<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>

                    <b-card-header>
                        <span class="h5">ITENS</span>
                        <b-button class="float-right"
                            v-if="temAcessoInserirItem && statusPermiteManipularItem"
                            variant="primary"
                            @click.stop="$emit('inserirItem')"
                        >
                            <span>
                                <i class="fa fa-plus mr-2"></i> Inserir Item
                            </span>
                        </b-button>
                    </b-card-header>

                    <b-card-body>
                        <div class="float-right">
                            <b-button class="float-right"
                                v-if="mostrarBtnAtualizarRateioEmMassa"
                                variant="success"
                                @click.stop="abrirAtualizarEmMassa()"
                            >
                                <span>
                                    <i class="fa fa-edit mr-2"></i> Atualiar rateios em massa
                                </span>
                            </b-button>
                            <div v-if="atualizandoRateioEmMassa">
                                <b-button
                                    class="float-right mr-2"
                                    variant="danger"
                                    @click="fecharAtualizarEmMassa()"
                                >
                                    <i class="fa fa-times-circle-o"></i> Cancelar
                                </b-button>
                                <!-- <b-button
                                    class="float-right mr-1"
                                    variant="primary"
                                    :disabled="!temItensAtualizarRateioEmMassa"
                                    @click.stop="toAtualizacaoEmMassa()"
                                >
                                    <i class="fa fa-floppy-o"></i> Atualizar Rateios
                                </b-button> -->
                            </div>
                        </div>

                        <app-tabela
                            idTabela="tblDespesas"
                            :itens="itens"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="quantidade" slot-scope="data">
                                {{ data.quantidade | currency2 }}
                            </template>
                            <template slot="precoUnitario" slot-scope="data">
                                {{ data.precoUnitario | currency }}
                            </template>
                            <template slot="valorUnitario" slot-scope="data">
                                {{ data.valorUnitario | currency }}
                            </template>
                            <template slot="valor" slot-scope="data">
                                {{ data.valor | currency }}
                            </template>

                            <template slot="qtdRateios" slot-scope="data">
                                {{ data.qtdRateios }}
                                <btn-justificativa-alteracao-rateio
                                    :item="data"
                                ></btn-justificativa-alteracao-rateio>
                            </template>

                            <template slot="HEAD_itensSelecao">
							<i
								class="
									fa fa-check-square fa-lg
									text-muted
									icon-button
									p-0
									m-0
								"
								title="Marcar/Desmarcar todos"
								@click.stop="marcarDesmarcarTodas()"
							></i>
						</template>

                            <template slot="itensSelecao" slot-scope="data" v-if="atualizandoRateioEmMassa">
                                <b-form-checkbox
                                    :value="data.despesaItemId"
                                    v-model="itensSelecioandos"
                                ></b-form-checkbox>
                            </template>

                            <template slot="itensAcoes" slot-scope="data">
                                <slot name="itensAcoes" v-bind="data"></slot>
                                    <btn-to-item-despesa
                                        :item="data"
                                        :rotaDetalharItem="rotaDetalharItem"
                                        v-if="temAcessoDetalharItem"
                                    ></btn-to-item-despesa>
                                    <span
                                        v-if="mostrarBtnAtualizarItem"
                                        class="text-primary ml-1"
                                    >
                                        <i
                                            class="fa fa-pencil-square-o fa-lg icon-button"
                                            title="Atualizar"
                                            @click.stop="$emit('atualizarItem', data)"
                                        ></i>
                                    </span>
                                    <span
                                        v-if="mostrarBtnExcluirItem"
                                        class="text-danger ml-1"
                                    >
                                        <i
                                            class="fa fa-trash fa-lg icon-button"
                                            title="Excluir"
                                            @click.stop="$emit('excluirItem', data)"
                                        ></i>
                                    </span>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
                <rateios-em-massa
                    v-if="atualizandoRateioEmMassa"
                    :unidades="unidades"
                    :projetos="projetos"
                    :acoes="acoes"
                    :temItensSelecionados="temItensAtualizarRateioEmMassa"
                    @obterUnidades="$emit('obterUnidades')"
                    @obterProjetos="$emit('obterProjetos', $event)"
                    @obterAcoes="$emit('obterAcoes', $event)"
                    @salvarRateios="adicionarItensARateiosEmMassa($event)"
                ></rateios-em-massa>
            </b-col>
        </b-row>       
    </div>
</template>

<script>
import BtnToItemDespesa from './BtnToItemDespesa.vue';
import BtnJustificativaAlteracaoRateio from './BtnJustificativaAlteracaoRateio.vue';
import RateiosEmMassa from '../rateios/RateiosEmMassa.vue';

export default {
    props: {        
        despesa: {
            type: Object,
            default: () => ({})
        },

        itens: {
            type: Array,
            default: () => []
        },

        temAcessoDetalharItem: {
            type: Boolean,
            default: () => false
        },

        rotaDetalharItem: {
            type: String
        },

        rotaAtualizacaoEmMassa: {
            type: String
        },

        temAcessoInserirItem: {
            type: Boolean,
            default: () => false
        },

        temAcessoAtualizarItem: {
            type: Boolean,
            default: () => false
        },

        statusPermiteAtualizar: {
            type: Boolean,
            default: () => false
        },

        statusPermiteManipularItem: {
            type: Boolean,
            default: () => false
        },

        unidades: {
            type: Array
        }, 

        projetos: {
            type: Array
        }, 
        
        acoes: {
            type: Array
        }
    },

    components: {
        BtnToItemDespesa,
        BtnJustificativaAlteracaoRateio,
        RateiosEmMassa
    },

    data() {
        return {
            mostrarModal: false,
            campos: [
                {
                    key: 'itensAcoes',
                    label: 'Ações'
                },
                {
                    key: 'nomeProduto',
                    label: 'Produto',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nomeNatureza',
                    label: 'Natureza',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nomeUnidade',
                    label: 'Unidade',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'qtdRateios',
                    label: 'Rateios',
                    tdClass: 'text-center'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valor',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 0,
            atualizandoRateioEmMassa: false,
            itensSelecioandos: []
        }
    },

    methods: {
        abrirAtualizarEmMassa() {
            this.atualizandoRateioEmMassa = true
        },
        
        fecharAtualizarEmMassa() {
            this.atualizandoRateioEmMassa = false
            this.itensSelecioandos = []
        },

        marcarDesmarcarTodas() {
			if (this.itensSelecioandos.length > 0) {
                this.itensSelecioandos = []
            } else {
				this.itensSelecioandos = this.itens.map(p => p.despesaItemId)
			}
		},

        toAtualizacaoEmMassa() {
            this.$router.push({
                name: this.rotaAtualizacaoEmMassa,
                params: {
                    idsItens: this.itensSelecioandos
                }
            })
        },

        adicionarItensARateiosEmMassa(rateios) {
            let rateiosDto = {
                itensId: this.itensSelecioandos,
                rateios: rateios.rateios,
                justificativa: rateios.justificativa
            }
            this.fecharAtualizarEmMassa()
            this.$emit('salvarRateios', rateiosDto)
        }
    },

    watch: {
        atualizandoRateioEmMassa() {
            if (this.atualizandoRateioEmMassa) { 
                this.campos.unshift({
                    key: 'itensSelecao',
                    label: ''
                })
            } else {
                this.campos.shift()
            }
        }
    },

    computed: {
        temAcessoAtualizarRateioEmMassa() {
            return ((
                        this.$route.name == 'DespesasGerais_Requisitantes_Despesas_Detalhar'
                        && this.statusPermiteAtualizarRateiosEmMassa
                        && this.$temAcessoView('DESP-GERAIS-REQ-03')
                    )
                    || (
                        this.$route.name == 'DespesasGerais_Fornecedores_Despesas_Detalhar'
                        && this.statusPermiteAtualizarRateiosEmMassa
                        && this.$temAcessoView('DESP-GERAIS-FORN-03')
                    )
                    || (
                        this.$route.name == 'DespesasGerais_Finalizacao_Despesas_Detalhar'
                        && this.statusPermiteAtualizarRateiosEmMassa
                        && this.$temAcessoView('DESP-GERAIS-FINAL-05')
                    )
                ) 
        },

        statusPermiteAtualizarRateiosEmMassa() {
            if (this.$route.name == 'DespesasGerais_Finalizacao_Despesas_Detalhar') {
                if (this.itens.length == 0) {
                    return false
                }
                return this.itens[0].despesa.statusId == 5
            }
            return this.statusPermiteAtualizar
        },

        temItensAtualizarRateioEmMassa() {
            return this.itensSelecioandos.length > 0
        },

        mostrarBtnAtualizarItem() {
            return this.temAcessoAtualizarItem 
                && this.statusPermiteAtualizar
                && !this.despesa.movimentoCompra
        },

        mostrarBtnExcluirItem() {
            return this.temAcessoAtualizarItem 
                && this.statusPermiteManipularItem
                && !this.despesa.movimentoCompra
        },

        mostrarBtnAtualizarRateioEmMassa() {
            return this.temAcessoAtualizarRateioEmMassa 
                && !this.atualizandoRateioEmMassa
                && !this.despesa.movimentoCompra    
        }   
    }
}
</script>